<lc-base-dialog [compact]="data.compact" [message]="message" [otherActions]="data.secondaryActions" [primaryAction]="data.primaryAction" [title]="data.title" (actionClicked)="onActionClicked($event)" />
